import styled from 'styled-components';
import { Virtuoso } from 'react-virtuoso';
import EmptyMessage from 'components/EmptyMessage';
import Badge from 'components/Badge';
import { color } from 'theme';
import { GREY_300, GREY_400, WHITE } from '../../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${(props) => props.theme.rainbow.palette.background.main};
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 16px 24px;
    border-bottom: 1px solid ${color('border.divider')};
    background-color: ${color('background.main')};
    min-height: 80px;
    gap: 0.5rem;

    button {
        height: 2rem;
        padding: 0 0.75rem;
        font-size: 0.8125rem;
        line-height: 1.5rem;
        white-space: nowrap;

        svg {
            width: 0.875rem;
            height: 0.875rem;
            margin-right: 0.375rem;
        }
    }
`;

export const Divider = styled.div`
    width: 1px;
    height: 100%;
    margin: 0 0.5rem;
    background-color: ${(props) => props.theme.rainbow.palette.border.divider};
    flex-shrink: 0;
`;

export const MessagesContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 1rem;
`;

export const StyledVirtuoso = styled(Virtuoso)`
    width: 100%;
    overflow-x: hidden;
` as unknown as typeof Virtuoso;

export const StyledEmptyMessage = styled(EmptyMessage)`
    color: ${GREY_400};
    border-radius: 10px;
    width: 75%;
    margin: 2rem auto 0 auto;
    padding: 8px 12px;
    color: ${GREY_400};
    text-align: center;
    font-size: 0.9375rem;
    font-weight: 300;
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px 24px;
`;

export const LoadingMessage = styled.div`
    height: 60px;
    background-color: ${(props) => props.theme.rainbow.palette.background.gray};
    border-radius: 18px;
    animation: pulse 1.5s ease-in-out infinite;
    
    @keyframes pulse {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }
`;

export const StyledBadge = styled(Badge)`
    background-color: ${WHITE};
    text-transform: none;
    align-self: center;
    box-sizing: border-box;
    flex-shrink: 0;
    border-radius: 0.25rem;
    border: 1px solid #DBDADE;
    display: flex;
    padding: 0.3125rem 0.625rem;
    align-items: center;
    gap: 0.625rem;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Space = styled.div`
    height: 12px;
`;

export const MessageInputWrapper = styled.div`
    position: relative;
`;

export const DisabledOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: not-allowed;
    z-index: 10;
`;

export const ReasonText = styled.div`
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    background-color: ${WHITE};
    border-radius: 0.5rem;
    max-width: 400px;
    width: 100%;
    color: ${GREY_300};
    font-size: 0.875rem;
    text-align: center;
    padding: 0.75rem 1rem 2rem;

    ${DisabledOverlay}:hover & {
        opacity: 1;
    }
`;
